import axios from 'axios'

const service = axios.create({
  baseURL: 'https://icloud.lhcoffeetime.com/', // url = base url + request url
  timeout: 60000 // request timeout
})

service.interceptors.request.use(
  config => {
    return config
  },
  error => {
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js